import React from 'react';

import Section from '../section';

const SectionAbout = ({ about }) => {
  const formattedAbout = about.replace('example', '<strong>example</strong>'); // Replace 'example' with the desired text to be bolded

  return (
    <Section title="About Me">
      <div className="mb-6" style={{ whiteSpace: 'pre-line' }}>
        <p dangerouslySetInnerHTML={{ __html: formattedAbout }}></p>
      </div>
    </Section>
  );
};

export default SectionAbout;
